import { Button } from '@tebuto/buttons/Button'
import { useState } from 'react'

interface ComponentErrorProps {
    retry?: () => void
}

export default function ComponentError({ retry }: ComponentErrorProps) {
    const [retryDisabled, setRetryDisabled] = useState(false)

    function handleRetry() {
        if (retry) {
            setRetryDisabled(true)
            retry()
            setTimeout(() => setRetryDisabled(false), 1000)
        }
    }

    return (
        <div className="grid min-h-full place-items-center px-6 py-10" data-testid="component-error">
            <div className="text-center">
                <p className="mt-6 text-base leading-7 ">
                    Entschuldigung. Da ist etwas schiefgelaufen.
                    <br />
                    Sollte der Fehler erneut auftreten, kontaktieren Sie uns bitte via{' '}
                    <a className="text-primary-600 underline" href="mailto:support@tebuto.de">
                        support@tebuto.de
                    </a>
                </p>
                {retry && (
                    <div className="mt-10 flex items-center justify-center gap-x-6">
                        <Button
                            className="w-max"
                            onClick={handleRetry}
                            disabled={retryDisabled}
                            data-testid="component-error-retry"
                        >
                            Erneut versuchen
                        </Button>
                    </div>
                )}
            </div>
        </div>
    )
}
